import { InsuranceCardActions } from 'src/Booking/actions/InsuranceCardActions';

const initialState = {
    insuranceCardScanned: false,
    scannedIceRequestToken: null,
    isFetchingInsuranceCards: true,
    isScannerOpen: false,
    isScannerLoading: false,
    scannedCardFetchRetryCount: 0,
    hasFetchError: false,
};

export const scanInsuranceCardReducer = (state = initialState, action) => {
    switch (action.type) {
        case InsuranceCardActions.SET_IS_FETCHING_CARDS:
            return {
                ...state,
                isFetchingInsuranceCards: action.payload,
            };
        case InsuranceCardActions.SCANNED_CARD_SUCCESS:
            return {
                ...state,
                insuranceCardScanned: true,
                scannedIceRequestToken: action.payload.correlationId,
            };
        case InsuranceCardActions.SET_SCANNED_CARD_SCANNER_OPEN_STATE:
            return {
                ...state,
                isScannerOpen: action.payload.isScannerOpen,
            };
        case InsuranceCardActions.SET_SCANNED_CARD_LOADING_STATE:
            return {
                ...state,
                isScannerLoading: action.payload.isLoading,
            };
        case InsuranceCardActions.SET_SCANNED_CARD_FETCH_RETRY_COUNT:
            return {
                ...state,
                scannedCardFetchRetryCount: action.payload.retryCount,
            };
        case InsuranceCardActions.SET_HAS_FETCH_SCANNED_CARD_ERROR:
            return {
                ...state,
                hasFetchError: action.payload.hasFetchError,
            };
        case InsuranceCardActions.TRACK_SCANNED_CARD_RETRY_METRICS:
        default:
            return state;
    }
};
